import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AAGoogleMapComponent } from './components/aa-google-map/aa-google-map.component';
import { TrafficAlertCarParkComponent } from './components/traffic-alert-car-park/traffic-alert-car-park.component';
import { GoogleMapsAPIWrapperService } from './services/google-map-wrapper/google-maps-api-wrapper.service';
import { AAGoogleContextMenuComponent } from './components/aa-google-context-menu/aa-google-context-menu.component';
import { HybridGoogleMapComponent } from './components/hybrid-google-map/hybrid-google-map.component';
import { GoogleMapTrafficWidgetComponent } from './components/google-map-traffic-widget/google-map-traffic-widget.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [FormsModule, CommonModule],
  exports: [
    AAGoogleMapComponent,
    HybridGoogleMapComponent
  ],
  declarations: [
    AAGoogleMapComponent,
    TrafficAlertCarParkComponent,
    AAGoogleContextMenuComponent,
    HybridGoogleMapComponent,
    GoogleMapTrafficWidgetComponent
  ],
  providers: [GoogleMapsAPIWrapperService]
})
export class AAGoogleMapModule {}
